import { MarketId } from '@velocity-exchange/common';
import { IsolatedMarketContentBlockType } from './hooks/useShouldShowIsolatedMarketContentBlock';
import { useDrawersStore } from 'src/stores/useDrawersStore';
import Link from 'src/components/primitives/Link/Link';
import DisabledOverlayMessage from 'src/components/Utils/DisabledOverlayMessage';
import useModal from 'src/components/Modals/hooks/useModal';
import TextButton from 'src/components/primitives/TextButton/TextButton';

export const IsolatedMarketContentBlock = (props: {
	blockType: IsolatedMarketContentBlockType;
	ticker?: string;
	marketId: MarketId;
	hasMultipleSubaccounts?: boolean;
}) => {
	const setDrawersStore = useDrawersStore((s) => s.set);
	const { show } = useModal();

	const handleOpenAddAccountModal = () => {
		show({ type: 'new_subaccount', props: {} });
	};

	const handleOpenAccountDrawer = () => {
		setDrawersStore((s) => {
			s.accounts.show = true;
		});
	};

	const handleOpenMarginSettings = () => {
		show({ type: 'settings', props: { view: 'margin' } });
	};

	const messageTitle =
		props.blockType === 'non-isolated-market-block'
			? 'How to Trade this Market'
			: 'Trading Disabled';
	const message =
		props.blockType === 'non-isolated-market-block' ? (
			<>
				<div>
					This account has a position or order open in a market ({props.ticker})
					where{' '}
					<Link
						href="https://docs.drift.trade/trading/market-specs#isolated"
						openInNewTab
					>
						Isolated Margin
					</Link>{' '}
					from other markets is required as a safety precaution.
				</div>
				<div>
					To trade this market, switch to another subaccount or close your{' '}
					{props.ticker} position.
				</div>
			</>
		) : (
			<>
				<div>
					To trade Pre-Launch Markets,{' '}
					<Link
						className="inline-flex"
						href="https://docs.drift.trade/trading/market-specs#isolated"
						openInNewTab
					>
						<span>Isolated Margin</span>
					</Link>{' '}
					is required:
				</div>
				<ul className="list-inside list-disc">
					<li>Close any open positions, orders, or non-USDC borrows</li>
					<li>Claim any unsettled P&L</li>
					<li>
						<TextButton
							size="sm"
							variant="tertiary"
							onClick={handleOpenMarginSettings}
						>
							Disable margin trading
						</TextButton>
					</li>
				</ul>
				<br />
				<div>
					Alternatively, you can create or switch to a different subaccount to
					trade.
				</div>
			</>
		);

	const action = props.hasMultipleSubaccounts
		? {
				onClick: () => handleOpenAccountDrawer(),

				label: 'Switch Subaccounts',
			}
		: {
				onClick: () => handleOpenAddAccountModal(),
				label: 'Create a Subaccount',
			};

	return (
		<DisabledOverlayMessage
			title={messageTitle}
			message={message}
			action={action}
		/>
	);
};
